let inboundlist = [
  { title: "Unloading and Unpacking", label: "cpunpack" },
  { title: "Transportation", label: "cpintrans" },
  { title: "Import Custom Clearance", label: "cpimport" },
  { title: "Ministry Approval", label: "cpministry" },
  { title: "Inspection", label: "cpinspect" },
];
export default inboundlist;
